import React from 'react';
import useWindowWidth from '../../hooks/useWindowWidth';
import './Dashboard.css';

const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);
};

const HIDDEN = '••••••';

// Versão compacta para mobile: 3 cartões em linha
function SummaryCardsMobile({ data, hideValues }) {
    const netResultColor = data?.net_result >= 0 ? '#16a34a' : '#dc2626';

    return (
        <div className="dash-summary-strip">
            <div className="dash-summary-card-m">
                <span className="dash-summary-label-m">Receitas</span>
                <span className="dash-summary-value-m" style={{ color: '#16a34a' }}>
                    {hideValues ? HIDDEN : formatCurrency(data?.total_revenue)}
                </span>
            </div>
            <div className="dash-summary-card-m">
                <span className="dash-summary-label-m">Despesas</span>
                <span className="dash-summary-value-m" style={{ color: '#dc2626' }}>
                    {hideValues ? HIDDEN : formatCurrency(data?.total_expense)}
                </span>
            </div>
            <div className="dash-summary-card-m">
                <span className="dash-summary-label-m">Resultado</span>
                <span className="dash-summary-value-m" style={{ color: netResultColor }}>
                    {hideValues ? HIDDEN : formatCurrency(data?.net_result)}
                </span>
            </div>
        </div>
    );
}

// Cartão individual para desktop
const SummaryCard = ({ title, value, colorClass = 'text-dark', hideValues }) => (
    <div className="col-lg-4 col-md-6 mb-4">
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="fs-6 text-muted">{title}</div>
                </div>
                <div className={`fs-2 fw-bold mt-2 ${colorClass}`}>
                    {hideValues ? HIDDEN : formatCurrency(value)}
                </div>
            </div>
        </div>
    </div>
);

function SummaryCards({ data, hideValues }) {
    const width = useWindowWidth();
    const isMobile = width < 768;

    if (isMobile) {
        return <SummaryCardsMobile data={data} hideValues={hideValues} />;
    }

    const netResultColor = data?.net_result >= 0 ? 'text-success' : 'text-danger';

    return (
        <div className="row mb-4">
            <SummaryCard title="Receita Total" value={data?.total_revenue} colorClass="text-success" hideValues={hideValues} />
            <SummaryCard title="Despesa Total" value={data?.total_expense} colorClass="text-danger" hideValues={hideValues} />
            <SummaryCard title="Resultado Líquido" value={data?.net_result} colorClass={netResultColor} hideValues={hideValues} />
        </div>
    );
}

export default SummaryCards;
